<div class="main-container">
  <div class="main-loader" *ngIf="isLoadingRemote">
    <mat-spinner diameter="60" strokeWidth="7"></mat-spinner>
  </div>
  <router-outlet></router-outlet>
</div>
